import { useEffect } from "react"
import { Form, Row, Col, Button } from "react-bootstrap"
import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { getForSelect as getAnimalsForSelect } from '../../../actions/other/animalsActions'
import { getBooleanOptions } from "../../../constants/booleanOptions"
import { getCauseOptions } from "../../../constants/causeOptions"
import { getConfirmationOptions } from "../../../constants/confirmationOptions"

export default function EventFormAbort({ type, state, handleInputChange, submit, isRegistering, isAddingOrEditing }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const { animalsForSelect } = useSelector(state => state.animals)

	useEffect(() => {
		dispatch(getAnimalsForSelect())
	}, [dispatch])

	const animals = animalsForSelect.map(a => ({ value: a._id, label: a.identifier }))

    const confirmationOptions = getConfirmationOptions(t)
    const causeOptions = getCauseOptions(t)
	const booleanOptions = getBooleanOptions(t)

	const showDetectionDate = type === 'heat'

	return (
		<Form onSubmit={submit} className="formulario">
			<h1 className="mb-4">{t('menus.event_abort')}</h1>

			<Row className="my-2">
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.animal.animals')}</Form.Label>
						<Select
							options={animals}
							value={animals.find(opt => opt.value === state.animals?.[0]) || null}
							onChange={opt => handleInputChange({ target: { name: 'animals', value: [opt.value] } })}
						/>
					</Form.Group>
				</Col>
			</Row>

			<Row className="my-2">
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.cause')}</Form.Label>
						<Select
							options={causeOptions}
							value={causeOptions.find(o => o.value === state.cause) || null}
							onChange={opt => handleInputChange({ target: { name: 'cause', value: opt.value } })}
						/>
					</Form.Group>
				</Col>

				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.cause_confirmation')}</Form.Label>
						<Select
							options={confirmationOptions}
							value={confirmationOptions.find(o => o.value === state.causeConfirmed) || null}
							onChange={opt => handleInputChange({ target: { name: 'causeConfirmed', value: opt.value } })}
						/>
					</Form.Group>
				</Col>
			</Row>

			<Row className="my-2">
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.reviewQuestion')}</Form.Label>
						<Select
							options={booleanOptions}
							value={booleanOptions.find(o => o.value === state.review) || null}
							onChange={opt => handleInputChange({ target: { name: 'review', value: opt.value } })}
						/>
					</Form.Group>
				</Col>
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.detectionDate')}</Form.Label>
						<Form.Control
							type="date"
							name="detectionDate"
							value={state.detectionDate || ''}
							onChange={handleInputChange}
							required={showDetectionDate}
						/>
					</Form.Group>
				</Col>
			</Row>

			<Row className="mt-4">
				<Col>
					<Button type="submit" className="w-100" variant="primary">
						{isRegistering
							? <span className="spinner-border spinner-border-sm" />
							: isAddingOrEditing === 'editing'
								? t('admin.animal.edit')
								: t('admin.animal.register')
						}
					</Button>
				</Col>
			</Row>
		</Form>
	)
}
